import debug from 'debug';
import ComponentStorage from 'Global/Shared/Components/ComponentStorage/ComponentStorage';
import Authentication from 'Minetilbud/Shared/Components/Authentication/Authentication';
import Settings from '../data/settings';

const log = debug('SearchBox:Utils:Shops');
const authentication = new Authentication();

class Shops {
	/**
	 * 'filter|shops' is set in \SearchResult\SearchResult.js
	 * @returns {string}
	 */
	static get() {
		const componentStorage = new ComponentStorage({ componentKey: Settings.componentKey });
		const value = componentStorage.getItem('filter|shops');
		
		if (value === null) return '';
		if (authentication.Authenticated()) return '';

		return `&shops=${value}`;
	}
}

export default Shops;
